import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Dehumidifier Icon Style 01 - Water Drop (Material Symbol)
 * - isOn = true: 藍色實心水滴 (FILL: 1)
 * - isOn = false: 灰色空心水滴 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:water_drop
 */
export const Style01_WaterDrop: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-blue-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      water_drop
    </span>
  );
};

export default Style01_WaterDrop;
